'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.makeEditorSaga = makeEditorSaga;

var _fsaSaga = require('@zaibot/fsa-saga');

var _es = require('@zaibot/fsa/es5');

var _effects = require('redux-saga/effects');

var _utils = require('../utils');

function interceptor(descriptor, actionType, cb) {
    return function* (action, next) {
        if ((0, _es.isType)(action, actionType)) {
            let item = yield (0, _effects.select)(descriptor.selectors.item);
            yield* cb(action, item);
        }
        yield* next(action);
    };
}
function stopMiddleware(descriptor, options) {
    return function* (action, next) {};
}
function resourceCreateImmediately(descriptor, options) {
    return interceptor(descriptor, descriptor.actions.CREATE, function* (action, item) {
        yield (0, _effects.put)(descriptor.resource.actions.CREATE({ item: item }));
    });
}
function resourceCreateDelayed(descriptor, options) {
    return interceptor(descriptor, descriptor.actions.CREATE, (action, item) => {});
}
function resourceCreateContinueImmediately(descriptor, options) {
    return interceptor(descriptor, descriptor.actions.CREATE_CONTINUE, function* (action, item) {
        yield (0, _effects.put)(descriptor.resource.actions.UPDATE({ item: item }));
    });
}
function resourceCreateContinueDelayed(descriptor, options) {
    return interceptor(descriptor, descriptor.actions.CREATE_CONTINUE, function* (action, item) {
        yield (0, _effects.put)(descriptor.resource.actions.CREATE({ item: item }));
    });
}
function resourceRead(descriptor, options) {
    return interceptor(descriptor, descriptor.actions.READ, function* (action, item) {
        let storeItem = yield (0, _effects.select)(descriptor.resource.selectors.itemByItem(item));
        yield (0, _effects.put)(descriptor.actions.APPLY({ item: storeItem }));
    });
}
function resourceUpdate(descriptor, options) {
    return interceptor(descriptor, descriptor.actions.UPDATE, function* (action, item) {
        yield (0, _effects.put)(descriptor.actions.APPLY({ item: item }));
    });
}
function resourceUpdateContinueImmediately(descriptor, options) {
    return interceptor(descriptor, descriptor.actions.UPDATE_CONTINUE, function* (action, item) {
        yield (0, _effects.put)(descriptor.resource.actions.UPDATE({ item: item }));
    });
}
function resourceUpdateContinueDelayed(descriptor, options) {
    return interceptor(descriptor, descriptor.actions.UPDATE_CONTINUE, function* (action, item) {
        let storeItem = yield (0, _effects.select)(descriptor.resource.selectors.itemByItem(item));
        if (storeItem && descriptor.resource.fields.hasCommited(storeItem)) {
            yield (0, _effects.put)(descriptor.resource.actions.UPDATE({ item: item }));
        } else {
            yield (0, _effects.put)(descriptor.resource.actions.CREATE({ item: item }));
        }
    });
}
function resourceDelete(descriptor, options) {
    return interceptor(descriptor, descriptor.actions.DELETE, function* (action, item) {
        let storeItem = yield (0, _effects.select)(descriptor.resource.selectors.itemByItem(item));
        yield (0, _effects.put)(descriptor.actions.APPLY({ item: storeItem }));
    });
}
function resourceDeleteContinue(descriptor, options) {
    return interceptor(descriptor, descriptor.actions.DELETE_CONTINUE, function* (action, item) {
        yield (0, _effects.put)(descriptor.resource.actions.DELETE({ item: item }));
    });
}
function makeEditorSaga(descriptor, options, middlewares) {
    let resource = descriptor.resource;

    let actions = [...descriptor.actions.all, ...resource.actions.all];
    let factories = [...middlewares, options.createImmediately ? resourceCreateImmediately : resourceCreateDelayed, options.createImmediately ? resourceCreateContinueImmediately : resourceCreateContinueDelayed, resourceRead, resourceUpdate, options.createImmediately ? resourceUpdateContinueImmediately : resourceUpdateContinueDelayed, resourceDelete, resourceDeleteContinue, stopMiddleware];
    let f = (0, _utils.applyMiddlewares)(...factories.map(mw => mw(descriptor, options)));
    return function* internal() {
        yield (0, _fsaSaga.takeEvery)(actions, f);
    };
}
//# sourceMappingURL=makeEditorSaga.js.map


// WEBPACK FOOTER //
// ./node_modules/redux-saga-resources/node/editor/makeEditorSaga.js